/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {Button} from "react-bootstrap";
import React from "react";
import {Glyphicon} from "./GlyphIcon";

export const GlyphButton = (props) => {
    
    const {
        glyph,
        children
    } = props;
    
    return <Button variant="link" {...props}>
        <Glyphicon glyph={glyph}>{children}</Glyphicon>
    </Button>
}
